import React, {Fragment, useCallback, useState} from 'react';
import {compose} from 'redux';
import {Button, ButtonProps, withStyles} from '@material-ui/core';
import {Delete as DeleteIcon} from '@material-ui/icons';
import {useTranslation} from 'react-i18next';
import ConfirmDeleteDialog from "../components/Dialogs/ConfirmDeleteDialog";
import classnames from "classnames";

interface DeleteButtonProps extends ButtonProps {
    loading?: boolean;
    className?: string;
    confirmDialogTitle?: string | JSX.Element | Array<JSX.Element>;
    confirmDialogContent?: string | JSX.Element | Array<JSX.Element>;
    record?: Record<string, any>;
    handleDelete: (id?: number | string) => void | Function;
    label?: string;
    icon?: React.ComponentType<any>;
}

interface InternalDeleteButtonProps extends DeleteButtonProps {
    classes: Record<string, string>;
}

const DeleteButtonView: React.FunctionComponent<InternalDeleteButtonProps> = ({
                                                                                  loading,
                                                                                  classes,
                                                                                  confirmDialogTitle,
                                                                                  confirmDialogContent,
                                                                                  record,
                                                                                  handleDelete,
                                                                                  icon,
                                                                                  label = 'actions.delete',
                                                                              }) => {
    const {t: translate} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const onCloseDialogCallback = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    const onOpenDialogCallback = useCallback((e) => {
        e && e.preventDefault();
        setIsOpen(true);
    }, [setIsOpen]);
    const onDeleteCallback = useCallback(() => {
        setIsOpen(false);
        handleDelete(record?.id);
    }, [handleDelete, record]);

    const Icon = icon || DeleteIcon;

    return (
        <Fragment>
            <Button
                onClick={onOpenDialogCallback}
                variant="contained"
                size="medium"
                className={classnames('btn-primary text-white', classes.deleteButton)}
                color="primary"
                disabled={loading}
            >
                <Icon className={classes.icon}/>
                {translate(label)}
            </Button>
            <ConfirmDeleteDialog
                title={confirmDialogTitle}
                content={confirmDialogContent}
                isOpen={isOpen}
                onClose={onCloseDialogCallback}
                onConfirm={onDeleteCallback}
                record={record}
            />
        </Fragment>
    );
};

const DeleteButton: React.ComponentType<DeleteButtonProps> = compose(
    withStyles({
        deleteButton: {
            background: '#FF3739',
            '&:hover': {
                background: '#AA3739',
            },
        },
        icon: {
            fontSize: '22px',
            paddingRight: '6px'
        },
    }),
)(DeleteButtonView);

export default DeleteButton;